export default class DoricResourceManager {
    constructor() {
        this.resourceLoaders = new Map();
    }
    registerLoader(loader) {
        this.resourceLoaders.set(loader.resourceType(), loader);
    }
    load(resource) {
        var _a;
        return (_a = this.resourceLoaders.get(resource.type)) === null || _a === void 0 ? void 0 : _a.load(resource.identifier);
    }
}
//# sourceMappingURL=DoricResourceManager.js.map